module.exports = __webpack_public_path__ + "img/img05.835ec6c6.png";